import React, { useCallback } from 'react';
import {ReadOnlySupport} from "./utils/ReadOnlySupport";
import {ReadOnlyBox} from "./utils/ReadOnlyBox";
import AntDatePicker from "../DatePicker";

function DatePickerReadOnly(props) {
    const { value, placeholder, disabled } = props;

    return (
        <ReadOnlyBox disabled={disabled}>
            {
                value?.format("DD/MM/YYYY") || (
                    placeholder ? <span className="placeholder">{placeholder}</span> : undefined
                )
            }
        </ReadOnlyBox>
    );
}

export const DatePicker = React.forwardRef((props, ref) => {
    const { children } = props;

    const whenReadOnly = useCallback(() => <DatePickerReadOnly {...props} />, [props]);

    const notReadOnly = useCallback(() => (
        <AntDatePicker {...props} pickerRef={ref}>
            {children}
        </AntDatePicker>
    ), [children, props, ref]);

    return <ReadOnlySupport
        {...props}
        whenReadOnly={whenReadOnly}
        notReadOnly={notReadOnly}
    />;
});
